import { useTranslation } from "react-i18next";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';

import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { motion } from 'framer-motion/dist/framer-motion'

import Tooltip from '@mui/material/Tooltip';

import AnotherSiteLink from '@mui/material/Link'
import React, { useState, useMemo, useRef } from 'react';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Grow from '@mui/material/Grow';
import FormControlLabel from '@mui/material/FormControlLabel';
import koma_corp from '../../assets/img/koma_corporation.png'
import { GithubStargazers } from './../utils/GithubStargazers';
import Button from '@material-ui/core/Button';
import GitHubIcon from '@mui/icons-material/GitHub';
import { Link } from 'react-router-dom';
import Pagination from '../utils/pagination/Pagination';
import ProjectsData from '../../data/projects-data.json'


let PageSize = 8;


const useStyles = makeStyles((theme) => ({
  projects: {

    paddingTop: "170px",
    "@media (max-width: 500px)": {
      paddingTop: "380px",
    },
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  cardsTopPadding: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(12),
  },
  card: {
    height: '38rem',
    display: 'flex',
    flexDirection: 'column',
    "@media (max-width: 1200px)": {
      height: '37rem',
    },
    "@media (max-width: 800px)": {
      height: '33rem',
    },
    "@media (max-width: 700px)": {
      height: '32rem',
    },
    "@media (max-width: 600px)": {
      height: '38rem',
    },
    "@media (max-width: 500px)": {
      height: '34rem',
    },
  },
  cardMedia: {
    paddingTop: '52.25%', // 16:9

  },

  cardContent: {
    flexGrow: 1,
  },
  title: {
    textAlign: 'center',
    textShadow: '1px 1px 1px black',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '200px',

    "@media (max-width: 500px)": {
      fontSize: '35px',
      marginLeft: "10px",
      marginRight: "10px",
    },
  },
  paginationBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-80px',
    marginBottom: '40px'
  },
  end: {
    textAlign: 'center',
    textShadow: '1px 1px 1px black',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '20px',
    marginRight: '40%',
    marginLeft: '40%',
    marginBottom: '150px',

    "@media (max-width: 500px)": {
      fontSize: '35px',
      marginLeft: "10px",
      marginRight: "10px",
      transform: 'scale(0.8)'
    },
  },
  switch: {
    transform: 'scale(1.3)'
  }
}));



export default function Projects(props) {

  const { t } = useTranslation();

  const classes = useStyles();

  const [checked, setChecked] = React.useState(true);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };



  const [currentPage, setCurrentPage] = useState(1);

  const currentProjectData = useMemo(() => {

    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return ProjectsData.slice(firstPageIndex, lastPageIndex);

  }, [currentPage]);





  return (
    <>
    <motion.div
                initial={{ opacity: 0, y: -180}}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                    delay:0.3
                }}
                >
    <Container maxWidth="lg" className={classes.projects}>


      <Typography variant="h3" align="center" paragraph className={classes.title}>
        <b>{t('projects')}</b><Box >
          <FormControlLabel labelPlacement="bottom"
            control={<Switch color="warning" className={classes.switch} checked={checked} onChange={handleChange} />}
            label={t('hide_show')}
          />
        </Box>
      </Typography>
      <hr />



      <Grid className={classes.cardsTopPadding} container spacing={2} >

        {currentProjectData.map(({ id, timeout_time, site_link, img, title, name, description, tech_img, github_stargazers_owner, github_stargazers_repo, season, year }) => (
          <Grow
            in={checked}
            style={{ transformOrigin: '0 0 0' }}
            {...(checked ? {} : {})}
          >
            <Grid item key={id} xs={12} sm={6} md={6}>
              <AnotherSiteLink target='_blank' href={site_link} style={{ textDecoration: 'none' }}>
                <CardActionArea>
                  <Card className={classes.card}>
                    <CardMedia
                      className={classes.cardMedia}
                      image={img}
                      title={t(title)}
                    />
                    <CardContent className={classes.cardContent}>
                      <Typography align="center" gutterBottom variant="h5" component="h2">
                        <b>{t(name)}</b>
                      </Typography>
                      <Typography align="center" variant="subtitle1">
                        {t(description)}
                      </Typography>
                      <Tooltip title={t('technologies')} arrow>
                        <Container align='center'>
                          <img src={tech_img} style={{ width: '40px', paddingTop: '5px' }} />


                        </Container>
                      </Tooltip>
                    </CardContent>


                    <CardActions>
                      <Container align='left'>
                        <GithubStargazers owner={github_stargazers_owner} repo={github_stargazers_repo} theme={props.darkMode ? 'dark' : 'light'} />
                      </Container>

                      <Container align='right'>
                        <Tooltip title={t('created')} arrow>
                          <Button variant="outlined" endIcon={<EventAvailableIcon fontSize="large" />}>
                            {t(season)} {year}
                          </Button>
                        </Tooltip>
                      </Container>
                    </CardActions>

                  </Card>
                </CardActionArea>
              </AnotherSiteLink>
            </Grid>
          </Grow>
        ))}


      </Grid>
      <div className={classes.paginationBar}>
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={ProjectsData.length}
          pageSize={PageSize}
          onPageChange={page => setCurrentPage(page)}

        />
      </div>

      <div style={{ marginBottom: '150px' }}>
        <AnotherSiteLink href="https://github.com/Ivan-Corporation">
          <Typography variant="h5" align="center" paragraph className={classes.end}>
            <b>{t('More on my Github')}</b>
            <br />
            <GitHubIcon fontSize="large" />
          </Typography>
        </AnotherSiteLink>
      </div>

    </Container>
    </motion.div></>
  )

}